import React, { useEffect } from "react";
import { useNavigate, Outlet } from "react-router-dom";
import { clearAuth, isAuthenticated } from "./api";

function ProtectedRoute({ children }) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated()) {
      clearAuth();
      navigate("/signin");
    }
  }, [navigate]);

  return <Outlet>{children}</Outlet>;
}

export default ProtectedRoute;
